import { render, staticRenderFns } from "./New-deals.vue?vue&type=template&id=195af1bc&scoped=true&"
import script from "./New-deals.vue?vue&type=script&lang=js&"
export * from "./New-deals.vue?vue&type=script&lang=js&"
import style0 from "./New-deals.vue?vue&type=style&index=0&id=195af1bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195af1bc",
  null
  
)

export default component.exports